module.exports = __webpack_public_path__ + "static/media/ico_checked.1d4e30c0.svg";